import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface EditorialAssistant {
    _id: string;
    fullName: string;
    email: string;
}

interface EditorialAssistantContextType {
    editorialAssistant: EditorialAssistant | null;
    token: string | null;
    isAuthenticated: boolean;
    logout: () => void;
    loading: boolean;
}

const EditorialAssistantContext = createContext<EditorialAssistantContextType>({
    editorialAssistant: null,
    token: null,
    isAuthenticated: false,
    logout: () => { },
    loading: true
});

export const useEditorialAssistant = () => useContext(EditorialAssistantContext);

export const EditorialAssistantProvider = ({ children }: { children: ReactNode }) => {
    const [editorialAssistant, setEditorialAssistant] = useState<EditorialAssistant | null>(null);
    const [token, setToken] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const storedToken = localStorage.getItem('editorialAssistantToken');
        const storedEditorialAssistant = localStorage.getItem('editorialAssistantData');

        if (storedToken && storedEditorialAssistant) {
            setToken(storedToken);
            setEditorialAssistant(JSON.parse(storedEditorialAssistant));
        }

        setLoading(false);
    }, []);

    const logout = () => {
        localStorage.removeItem('editorialAssistantToken');
        localStorage.removeItem('editorialAssistantData');
        setEditorialAssistant(null);
        setToken(null);
        // This role is embedded as a tab inside the unified dashboard, so logging out
        // here should return to the unified login, not this role's standalone one.
        window.location.href = '/login';
    };

    return (
        <EditorialAssistantContext.Provider value={{
            editorialAssistant,
            token,
            isAuthenticated: !!token && !!editorialAssistant,
            logout,
            loading
        }}>
            {children}
        </EditorialAssistantContext.Provider>
    );
};
